import { z } from "zod";

export const departmentSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  memberCount: z.number().int().nonnegative(),
  createdAt: z.string(),
  deletedAt: z.string().nullable(),
  version: z.number().int(),
});
export type Department = z.infer<typeof departmentSchema>;

export const listDepartmentsResponseSchema = z.object({
  items: z.array(departmentSchema),
});
export type ListDepartmentsResponse = z.infer<typeof listDepartmentsResponseSchema>;

export const createDepartmentSchema = z
  .object({
    name: z.string().min(1).max(100),
    slug: z
      .string()
      .min(1)
      .max(60)
      .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
      .optional(),
  })
  .strict();
export type CreateDepartmentInput = z.infer<typeof createDepartmentSchema>;

export const updateDepartmentSchema = z
  .object({
    name: z.string().min(1).max(100).optional(),
    slug: z
      .string()
      .min(1)
      .max(60)
      .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
      .optional(),
  })
  .strict();
export type UpdateDepartmentInput = z.infer<typeof updateDepartmentSchema>;
